onePulse.controller('LaunchController', ['$scope', function ($scope) {

}]);
